import {
    getForcedControlGroup,
    getForcedTest1Group,
    getForcedTest2Group,
    getForcedTest3Group,
    getForcedTestGroup,
} from "@/utils/settings";

export enum ExperimentIds {
    // do not remove this is permanent exp for splitting users into segments
    SEGMENTS = "segments",
    GIFT_ON_EMAIL_SCREEN = "webtest_gift_on_email_screen_iter2_GW_1674_may25",
    NEW_BODY_SCAN_PAYWALL = "webtest_new_body_scan_paywall_FAEX_737_jun25", //roll back
    NUTRITION_SUPPLEMENTS_BUNDLE = "webtest_bundle_nutrition_supplements_FAEX_731_jun25",
    PERSONALIZED_NUTRITION_GUIDE_V2 = "webtest_personalized_nutrition_guide_v2_FAEX_736_jun25",
    NEW_BODY_SCAN_PAYWALL_LOCKED_VERSION = "webtest_body_scan_locked_FAEX_747_jul25", //roll out
    ONE_FOLD_UPSELLS = "webtest_upsells_new_style_FAEX_757_jul25", //roll back
    PAYWALL_WITH_PER_DAY_VALUES = "webtest_paywall_with_per_day_values_FAEX_837_aug25",
    MOST_POPULAR_PLAN = "webtest_most_popular_plan_FAEX_811_aug25",
    NUTRITION_SUPPLEMENTS_BUNDLE_ITER2 = "webtest_bundle_nutrition_supplements_FAEX_769_aug25",
    KICKBOX_VALIDATION = "webtest_kickbox_GW_2021_aug25",
    INTEGRATE_VENMO = "webtest_integrate_venmo_FAEX_613_nov_25",
    ROLL_BACK_SIMPLE_PRICES = "webtest_roll_back_simple_prices_GW_2145_nov25",
    FEM_REMOVE_AI_QUESTION = "webtest_fem_remove_ai_question_FAEX_1042_nov25",
    WEEKLY_PRICE_INCREASE = "webtest_weekly_price_increase_FAEX_1047_dec_25",
    REPLACE_FEMALE_VISUALS_FOR_ADULT_AUDIENCE_V2 = "webtest_replace_female_visuals_for_adult_audience_v2_FAEX_1051_dec25",
    ZING_PRO_V1 = "webtest_zing_pro_v1_FAEX_966_nov25",
    PLAN_RECOMMENDATION_HIGH_INTENT = "webtest_plan_recommendation_high_intent_FAEX_1027_dec25",
    PLAN_RECOMMENDATION_LOW_INTENT = "webtest_plan_recommendation_low_intent_FAEX_1027_dec25",
    MALE_REMOVE_HIGH_DROP_OFF_SCREENS_V2 = "webtest_male_remove_high_drop_off_screens_v2_FAEX_1118_jan26",
    FOUR_WEEK_PLAN_REMOVE_1WEEK = "webtest_4_week_plan_remove_1w_FAEX_1128_feb26",
    REDUCE_TIER_2_3_PRICE = "webtest_price_reduction_tier2_3_FAEX_1131_feb26",
    LES_MILLS_UPGRADE_V1 = "webtest_les_mills_upgrade_v1_FAEX_1126_mar26",
    YEARLY_PLAN_FAEX1136 = "webtest_yearly_plan_FAEX_1136_mar26",
    UPGRADED_TRAINING_PROGRAM = "webtest_training_program_GW_2312_mar26",
    MALE_FUNNEL_REDESIGN = "webtest_male_funnel_redesign_FAEX_1096_apr26",
    GPAY_NYSC_LANDING = "webtest_gpay_nysc_landing_apr26",
}

export const enum ExperimentVariants {
    CONTROL = "control",
    TEST = "test",
    TEST_1 = "test_1",
    TEST_2 = "test_2",
    TEST_3 = "test_3",
    NOT_ALLOCATED = "not_allocated",
    SEGMENT_A = "segment_A",
    SEGMENT_B = "segment_B",
}

export const TEST_VARIANTS = [
    ExperimentVariants.TEST,
    ExperimentVariants.TEST_1,
    ExperimentVariants.TEST_2,
    ExperimentVariants.TEST_3,
];

export const groupByForcedParams: Record<ExperimentVariants, string[]> = {
    [ExperimentVariants.CONTROL]: getForcedControlGroup(),
    [ExperimentVariants.TEST]: getForcedTestGroup(),
    [ExperimentVariants.TEST_1]: getForcedTest1Group(),
    [ExperimentVariants.TEST_2]: getForcedTest2Group(),
    [ExperimentVariants.TEST_3]: getForcedTest3Group(),
    [ExperimentVariants.NOT_ALLOCATED]: [],
    [ExperimentVariants.SEGMENT_A]: [],
    [ExperimentVariants.SEGMENT_B]: [],
};

// need to track paywall id for analytics
export const paywallExperimentsIds = [
    ExperimentIds.PAYWALL_WITH_PER_DAY_VALUES,
    ExperimentIds.MOST_POPULAR_PLAN,
    ExperimentIds.INTEGRATE_VENMO,
    ExperimentIds.WEEKLY_PRICE_INCREASE,
    ExperimentIds.ZING_PRO_V1,
    ExperimentIds.PLAN_RECOMMENDATION_HIGH_INTENT,
    ExperimentIds.PLAN_RECOMMENDATION_LOW_INTENT,
    ExperimentIds.FOUR_WEEK_PLAN_REMOVE_1WEEK,
    ExperimentIds.YEARLY_PLAN_FAEX1136,
];
